// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/StarRating/styles.css
// module id = 2839
// module chunks = 29